// Web setup must run before any app code
import './src/web/setup';

import React from 'react';
import { AppRegistry, View, useWindowDimensions } from 'react-native';
import WebErrorBoundary from './src/web/ErrorBoundary';
import App from './App';
import { name as appName } from './app.json';

function PhoneFrame({ children }) {
  const { width } = useWindowDimensions();
  const isDesktop = width > 500;

  if (!isDesktop) {
    return children;
  }

  return (
    <View style={{
      flex: 1,
      backgroundColor: '#f0f0f0',
      alignItems: 'center',
      justifyContent: 'center',
    }}>
      <View style={{
        width: 430,
        height: '95%',
        maxHeight: 932,
        borderRadius: 0,
        overflow: 'hidden',
        backgroundColor: '#fff',
        boxShadow: '0 25px 80px rgba(0,0,0,0.15), 0 0 0 1px rgba(0,0,0,0.08)',
      }}>
        {children}
      </View>
    </View>
  );
}

function Root() {
  return (
    <WebErrorBoundary>
      <PhoneFrame>
        <App />
      </PhoneFrame>
    </WebErrorBoundary>
  );
}

AppRegistry.registerComponent(appName, () => Root);
AppRegistry.runApplication(appName, {
  initialProps: {},
  rootTag: document.getElementById('root'),
});
